module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Flatten-6af5ea84aa8c25366fc387c9f409804f.svg";